import { Icons } from 'icons';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  update_block: {
    padding: '10px',
  },
  header: {
    fontSize: 'large',
    fontWeight: 'bold',
  },
  subheader: {
    fontSize: 'large',
  },
  date: {
    fontSize: 'x-small',
  },
  signature: {
    width: '125px',
    height: '84px',
  },
});

export interface Release0312Props {
  className?: string;
}

const Release0312 = ({ className }: Release0312Props) => {
  const styles = useStyles();

  return (
    <div>
      <div className={styles.update_block}>
        <hr />
        <div>
          <div className={styles.subheader}>
            3.1.2 <span className={styles.date}>(2025-02-09)</span>
          </div>
          <br />
          Changes:
          <br />
          <ul>
            <li>
              <i>Added ], {'}'}, and &gt; as punctuation characters.</i>
            </li>
          </ul>
          <br />
          <img className={styles.signature} src={Icons.Signature}></img>
          <br />
          <a href='mailto:auriana@ffxiv-toolkit.com'>
            &lt;auriana@ffxiv-toolkit.com&gt;
          </a>
        </div>
      </div>
    </div>
  );
};
export default Release0312;
